import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_API_PATH;

export const getInterviewById = async (interviewId) => {
    const res = await axios.get(`${baseUrl}/ebench/interview/get_interview_by_interviewId?interviewId=${interviewId}`);
    return res.data?.data;
};

export const getInterviewAllRoundByUUId = async (id) => {
    const res = await axios.get(`${baseUrl}/ebench/interview/grouped-by-uuid?uuid=${id}`);
    return res.data;
};

export const InterviewStatusChange = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}/ebench/interview/change_interview_status?interview_id=${id}`);
        toast.success('status change successfully!');
        return response;
    } catch (error) {
        toast.error('Failed to change status. Please try again.');
        console.error('postLaterApi error:', error);
        throw error; // re-throw if you want to handle it further where it's called
    }
};

export const InterviewComplete = async (id) => {
    try {
        const response = await axios.put(`${baseUrl}/ebench/interview/interviewClosed`, id);
        toast.success('Job interview completed successfully!');
        return response;
    } catch (error) {
        toast.error('Failed to interview completed. Please try again.');
        console.error('postLaterApi error:', error);
        throw error; // re-throw if you want to handle it further where it's called
    }
};